import Company from '@/fstore/collections/Company';

const getByUserId = async ({ commit, dispatch }, userID) => {
  dispatch('app/setOverlay', true, { root: true })

  try {
    const company = await Company.getByUserId(userID);
    commit('setData', company)
  } catch (error) {
    dispatch('app/setAlert', {
      type: 'danger',
      message: error.message
    }, { root: true })
  }

  dispatch('app/setOverlay', false, { root: true })
}

const update = async ({ commit, dispatch }, company) => {
  dispatch('app/setOverlay', true, { root: true });

  await Company.update(company.uid, company);

  commit('setData', company);

  dispatch('app/setOverlay', false, { root: true });
}

const reset = ({ commit }) => {
  commit('setData', {});
}

export default {
  getByUserId,
  update,
  reset
}